import React, { useState } from 'react';

const periodSlides = [
  {
    title: 'Menstrual Phase Care',
    image: '/p1.webp',
    tips: [
      'Use a heating pad to ease cramps',
      'Stay hydrated to reduce bloating',
      'Choose iron-rich foods like lentils',
      'Rest and get enough sleep',
      'Wear comfy clothing',
      'Avoid caffeine if feeling anxious',
      'Track your flow and symptoms',
    ],
  },
  {
    title: 'Follicular Phase Tips',
    image: '/p3.png',
    tips: [
      'Try light cardio or yoga',
      'Focus on protein-rich foods',
      'Practice mindfulness to boost mood',
      'Plan social or creative activities',
      'Increase intake of leafy greens',
      'Stay consistent with water intake',
      'Track energy and mood spikes',
    ],
  },
  {
    title: 'Ovulation Phase Tips',
    image: '/p1.webp',
    tips: [
      'Stay active and energetic',
      'Boost hydration with fruits',
      'Consider using ovulation test kits',
      'Practice safe sex or plan for conception',
      'Eat anti-inflammatory foods',
      'Keep a journal of changes',
      'Be mindful of heightened emotions',
    ],
  },
  {
    title: 'Luteal Phase Care',
    image: '/p3.png',
    tips: [
      'Avoid salty or sugary foods',
      'Get enough sleep to reduce irritability',
      'Do light stretches or walks',
      'Include magnesium-rich foods like bananas',
      'Take breaks if you feel fatigued',
      'Manage PMS with calming routines',
      'Reduce screen time before bed',
    ],
  },
];

const PeriodTipsCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrent((current + 1) % periodSlides.length);
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrent((current - 1 + periodSlides.length) % periodSlides.length);
      setTimeout(() => setIsTransitioning(false), 500);
    }
  };

  const { title, tips, image } = periodSlides[current];

  return (
    <div
      className="carousel-container"
      style={{
        width: '500px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '20px',
        padding: '20px',
        border: '1px solid #eee',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
          transform: isTransitioning ? 'translateX(-20px)' : 'translateX(0)',
          opacity: isTransitioning ? 0 : 1,
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: '160px',
            height: '222px',
            marginTop: '60px',
            borderRadius: '10px',
            objectFit: 'cover',
            transition: 'transform 0.3s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        />
      </div>

      <div
        style={{
          transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
          transform: isTransitioning ? 'translateX(20px)' : 'translateX(0)',
          opacity: isTransitioning ? 0 : 1,
        }}
      >
        <h4
          style={{
            fontSize: '20px',
            color: '#B85170',
            minHeight: '48px',
            transition: 'color 0.3s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.color = '#9a3f5a'}
          onMouseOut={(e) => e.currentTarget.style.color = '#B85170'}
        >
          {title}
        </h4>

        <ul
          style={{
            fontSize: '16px',
            color: '#444',
            lineHeight: '1.8',
            listStyleType: 'disc',
            paddingLeft: '20px',
            margin: 0,
            maxHeight: '260px',
            overflowY: 'auto',
          }}
        >
          {tips.map((tip, idx) => (
            <li 
              key={idx}
              style={{
                transition: 'transform 0.2s ease',
                cursor: 'pointer',
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              {tip}
            </li>
          ))}
        </ul>

        <div style={{ marginTop: '10px' }}>
          <button 
            onClick={prevSlide} 
            style={{ 
              marginRight: '10px', 
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#B85170',
              color: 'white',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#9a3f5a';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#B85170';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            ←
          </button>
          <button 
            onClick={nextSlide} 
            style={{ 
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#B85170',
              color: 'white',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease, transform 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#9a3f5a';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#B85170';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PeriodTipsCarousel;